<div class="container" [class.modo-somente-leitura]="modoSomenteLeitura">
  <!-- Botão Voltar -->
  <div class="d-flex align-items-center mb-3">
    <a class="btn-back" [routerLink]="[isConferidor ? '/page/conferidor/servidores' : '/page/servidores']" [queryParams]="isConferidor ? { idCidade: idCidade } : {}">
      <i class="fa fa-arrow-left"></i> Voltar
    </a>
    <span class="ml-2">{{ isConferidor ? 'Servidores para Conferência' : 'Servidores do Município' }} > Servidor</span>
    <span
      class="badge ml-2"
      [ngClass]="temPermissaoEdicaoCompletaPosConferencia() ? 'badge-success' : 'badge-secondary'"
      *ngIf="modoSomenteLeitura || temPermissaoEdicaoCompletaPosConferencia()">
      {{ temPermissaoEdicaoCompletaPosConferencia() ? 'Edição pós-conferência liberada' : descricaoModoVisualizacao() }}
    </span>
  </div>

  <!-- Skeleton de carregamento (conexões lentas) -->
  <div class="row gx-3" *ngIf="carregando">
    <div class="col-lg-9 col-md-8">
      <div class="card p-3 shadow-sm mb-3">
        <div class="d-flex align-items-center">
          <div class="skeleton skeleton-avatar mr-3"></div>
          <div class="flex-grow-1">
            <div class="skeleton skeleton-line w-50 mb-2"></div>
            <div class="skeleton skeleton-line w-25"></div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-6" *ngFor="let i of skeletonRows">
            <div class="skeleton skeleton-line w-25 mb-2"></div>
            <div class="skeleton skeleton-input mb-3"></div>
          </div>
        </div>
      </div>
      <div class="card p-3 shadow-sm">
        <div class="skeleton skeleton-line w-25 mb-3"></div>
        <div class="skeleton skeleton-block"></div>
      </div>
    </div>
    <div class="col-lg-3 col-md-4">
      <div class="card p-3 shadow-sm">
        <div class="skeleton skeleton-line w-50 mb-3"></div>
        <div class="skeleton skeleton-line w-100 mb-2"></div>
        <div class="skeleton skeleton-line w-75 mb-2"></div>
        <div class="skeleton skeleton-input mt-3"></div>
      </div>
    </div>
  </div>

  <!-- Estado de erro na carga inicial -->
  <div class="row gx-3" *ngIf="!carregando && erroCarregamento">
    <div class="col-12">
      <div class="card p-4 shadow-sm text-center">
        <div class="mb-2" style="font-size: 2.5rem; color: #e0a800">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <h4 class="mb-2">Não foi possível carregar os dados do servidor</h4>
        <p class="text-muted mb-3">
          Verifique sua conexão e tente novamente.
        </p>
        <div>
          <button type="button" class="btn btn-primary" (click)="recarregar()">
            <i class="fa fa-refresh mr-1"></i> Recarregar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row gx-3 ficha-layout-row" *ngIf="!carregando && !erroCarregamento">
    <!-- Card Principal do Servidor -->
    <div
      class="ficha-conteudo col-lg-9 col-md-8"
    >
      <div class="server-data">
        <div class="card p-3 shadow-sm">
          <div class="row align-items-center">
            <!-- Coluna da imagem -->
            <div class="col-auto position-relative">
              <img
                [src]="
                  servidor && servidor.imagem
                    ? servidor.imagem
                    : 'assets/img/portrait/small/no-avatar.svg'
                "
                alt="Foto do servidor"
                class="rounded-circle servidor-avatar"
              />
              <img
                src="../../assets/img/edit_profile_image.png"
                (click)="openModalSm(modalFoto)"
                alt="Ícone de câmera"
                class="camera-icon"
                *ngIf="podeEditarDadosServidor()"
              />
            </div>

            <!-- Coluna das informações -->
            <div class="col">
              <h3 class="mb-1">
                {{ servidor && servidor.nome ? servidor.nome : "-----" }}
              </h3>
              <p class="mb-0">
                <b style="font-weight: 600">CPF:</b>
                {{
                  servidor && servidor.cpf
                    ? (servidor?.cpf | mask : "000.000.000-00")
                    : "-----"
                }}
              </p>
            </div>
            <div class="col-auto server-status-col">
              <div class="status-servidor-lista">
                <ng-container *ngFor="let status of getStatusServidor(); let ultimo = last">
                  <span class="status-servidor" [ngClass]="getStatusClass(status)">
                    {{ getStatus(status) }}
                  </span>
                  <span class="status-separador" *ngIf="!ultimo">|</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações Básicas do Benefício -->
      <div class="benefit-info">
        <div class="card">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-header-leading">
              <div class="card-title-group">
                <h4>Dados Principais</h4>
                <span>Dados do CPF</span>
              </div>
              <label class="conferencia-check" [class.conferido]="conferenciaBlocos.principal" *ngIf="isConferidor && !modoSomenteLeitura">
                <input
                  type="checkbox"
                  [(ngModel)]="conferenciaBlocos.principal"
                  [ngModelOptions]="{ standalone: true }"
                />
                Conferido?
              </label>
            </div>
            <div class="card-header-actions">
              <button class="btn-no-border" (click)="togglePrincipalData()">
                {{ isPrincipalDataVisible ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
          </div>

          <div class="card-body" *ngIf="isPrincipalDataVisible">
            <ngb-tabset
              (tabChange)="onTabChange($event)"
              type="tabs"
              class="custom-tabs"
            >
              <ngb-tab title="Informações Básicas">
                <ng-template ngbTabContent>
                  <form *ngIf="servidor" #servForm="ngForm" class="formulario-validavel formulario-basico" novalidate>
                    <h5 class="text-left mt-2">Informações Básicas</h5>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="nome"
                              >Nome <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <input
                              type="text"
                              id="nome"
                              class="form-control"
                              [(ngModel)]="servidor.nome"
                              name="nome"
                              placeholder="Nome Completo"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'nome')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'nome')"
                              [disabled]="!isEditingBasicInfos"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'nome')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "nome") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="sexo"
                              >Sexo <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="sexos"
                              name="sexo"
                              bindLabel="name"
                              placeholder="Sexo"
                              bindValue="id"
                              id="sexo"
                              [(ngModel)]="servidor.sexo"
                              [class.is-invalid]="erroCampoFormulario('basico', 'sexo')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'sexo')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'sexo')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "sexo") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_nascimento"
                              >Nascimento <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <input
                              type="text"
                              id="data_nascimento"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="servidor.data_nascimento"
                              name="data_nascimento"
                              placeholder="Data Nascimento"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'data_nascimento')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'data_nascimento')"
                              [disabled]="!isEditingBasicInfos"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'data_nascimento')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "data_nascimento") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="estado_civil"
                              >Estado Civil <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="estadosCivis"
                              name="estado_civil"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Estado Civil"
                              id="estado_civil"
                              (change)="filter()"
                              [(ngModel)]="servidor.estado_civil"
                              [class.is-invalid]="erroCampoFormulario('basico', 'estado_civil')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'estado_civil')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'estado_civil')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "estado_civil") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="mae"
                              >Nome Mãe <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <input
                              type="text"
                              id="mae"
                              class="form-control"
                              [(ngModel)]="servidor.nome_mae"
                              name="nome_mae"
                              placeholder="Nome Mãe"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'nome_mae')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'nome_mae')"
                              [disabled]="!isEditingBasicInfos"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'nome_mae')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "nome_mae") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="pai"
                              >Nome Pai <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <input
                              type="text"
                              id="pai"
                              class="form-control"
                              [(ngModel)]="servidor.nome_pai"
                              name="nome_pai"
                              placeholder="Nome Pai"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'nome_pai')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'nome_pai')"
                              [disabled]="!isEditingBasicInfos"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'nome_pai')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "nome_pai") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Localização e Nacionalidade</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="nacionalidade"
                              >Nacionalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <input
                              type="text"
                              id="nacionalidade"
                              class="form-control"
                              [(ngModel)]="servidor.nacionalidade"
                              name="nacionalidade"
                              placeholder="Nacionalidade"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'nacionalidade')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'nacionalidade')"
                              [disabled]="!isEditingBasicInfos"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'nacionalidade')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "nacionalidade") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="naturalizado"
                              >Naturalizado <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="naturalizados"
                              name="naturalizado"
                              bindLabel="name"
                              placeholder="Naturalizado"
                              bindValue="id"
                              id="naturalizado"
                              [(ngModel)]="servidor.naturalizado"
                              [class.is-invalid]="erroCampoFormulario('basico', 'naturalizado')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'naturalizado')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'naturalizado')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "naturalizado") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="estado_naturalidade"
                              >UF de Naturalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="estados"
                              name="estado_naturalidade"
                              (change)="toggleEstado()"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="UF de Naturalidade"
                              id="estado_naturalidade"
                              [(ngModel)]="servidor.estado_naturalidade"
                              [class.is-invalid]="erroCampoFormulario('basico', 'estado_naturalidade')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'estado_naturalidade')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'estado_naturalidade')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "estado_naturalidade") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cidade_naturalidade"
                              >Cidade de Naturalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="cidades"
                              name="cidade_naturalidade"
                              bindLabel="nome"
                              bindValue="id"
                              placeholder="Cidade de Naturalidade"
                              id="cidade_naturalidade"
                              [(ngModel)]="servidor.cidade_naturalidade"
                              [class.is-invalid]="erroCampoFormulario('basico', 'cidade_naturalidade')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'cidade_naturalidade')"
                              [disabled]="!isEditingBasicInfos || !cidades || cidades.length == 0"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'cidade_naturalidade')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "cidade_naturalidade") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Dados Complementares</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="escolaridade"
                              >Escolaridade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="escolaridades"
                              name="escolaridade"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Escolaridade"
                              id="escolaridade"
                              [(ngModel)]="servidor.escolaridade"
                              [class.is-invalid]="erroCampoFormulario('basico', 'escolaridade')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'escolaridade')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'escolaridade')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "escolaridade") }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="deficiente"
                              >Pessoa com deficiência - PCD
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                            >
                            <ng-select
                              [items]="naturalizados"
                              name="deficiente"
                              bindLabel="name"
                              placeholder="Deficiente"
                              bindValue="id"
                              id="deficiente"
                              [(ngModel)]="servidor.deficiente"
                              [class.is-invalid]="erroCampoFormulario('basico', 'deficiente')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'deficiente')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'deficiente')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "deficiente") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="form-row"
                      *ngIf="servidor && servidor.status == 2"
                    >
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_ingresso">Ingresso no Serviço Público</label>
                            <input
                              type="text"
                              id="data_ingresso"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="servidor.data_ingresso_servico_publico"
                              name="data_ingresso"
                              placeholder="Data de Ingresso no Serviço Público"
                              [disabled]="!isEditingBasicInfos"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="form-row"
                      *ngIf="servidor && servidor.status == 3"
                    >
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="idade">Idade</label>
                            <input
                              type="text"
                              id="idade"
                              class="form-control"
                              [(ngModel)]="servidor.idade"
                              name="idade"
                              placeholder="Idade"
                              disabled
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="tipo_vinculo">
                              Tipo de Vínculo
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="tipoVinculo"
                              name="tipo_vinculo"
                              bindLabel="name"
                              placeholder="Tipo de Vínculo"
                              id="tipo_vinculo"
                              [(ngModel)]="servidor.tipo_vinculo"
                              [class.is-invalid]="erroCampoFormulario('basico', 'tipo_vinculo')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'tipo_vinculo')"
                              [disabled]="!isEditingBasicInfos"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('basico', 'tipo_vinculo')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "tipo_vinculo") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="servidor && (servidor.status == 4 || servidor.status == 5)">
                      <hr />
                      <h5 class="text-left mt-2">Informações Complementares</h5>
                    </ng-container>

                    <div
                      class="form-row"
                      *ngIf="servidor && servidor.status == 4"
                    >
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="motivo_exoneracao">Motivo Exoneração</label>
                            <input
                              type="text"
                              id="motivo_exoneracao"
                              class="form-control"
                              [(ngModel)]="servidor.motivo_exoneracao"
                              name="motivo_exoneracao"
                              placeholder="Motivo Exoneração"
                              [disabled]="!isEditingBasicInfos"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="form-row"
                      *ngIf="servidor && servidor.status == 5"
                    >
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_falecimento">
                              Data Falecimento
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="data_falecimento"
                              class="form-control"
                              mask="00/00/0000"
                              [disabled]="!isEditingBasicInfos"
                              [(ngModel)]="servidor.data_falecimento"
                              name="data_falecimento"
                              placeholder="Data do Falecimento"
                              required
                              [class.is-invalid]="erroCampoFormulario('basico', 'data_falecimento')"
                              [attr.aria-invalid]="!!erroCampoFormulario('basico', 'data_falecimento')"
                            />
                            <div *ngIf="erroCampoFormulario('basico', 'data_falecimento')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("basico", "data_falecimento") }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="docingresso">Documento de Ingresso</label>
                            <input
                              type="text"
                              id="docingresso"
                              class="form-control"
                              [disabled]="!isEditingBasicInfos"
                              [(ngModel)]="servidor.documento_ingresso_servico_publico"
                              name="docingresso"
                              placeholder="Documento de Ingresso"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Botão "Editar" quando isEditingBasicInfos for false -->
                      <div class="col" *ngIf="!isEditingBasicInfos && podeEditarDadosServidor()">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="toggleEditBasicInfos()"
                        >
                          Editar
                        </button>
                      </div>

                      <!-- Botões "Salvar" e "Cancelar" quando isEditingBasicInfos for true -->
                      <div class="col" *ngIf="isEditingBasicInfos">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="editarServidor(true)"
                        >
                          Salvar
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-primary mb-2 mb-md-0 mr-2 float-right"
                          (click)="toggleEditBasicInfos(true)"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-tab>

              <ngb-tab title="Dados Pessoais">
                <ng-template ngbTabContent>
                  <h5 class="text-left mt-2">Endereço</h5>

                  <form
                    #dadosPessoaisForm="ngForm"
                    class="dados-pessoais-form"
                    (ngSubmit)="atualizarOuCadastrarContato()"
                    novalidate
                  >
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cep">
                              CEP
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="cep"
                              class="form-control"
                              [(ngModel)]="endereco.cep"
                              mask="00.000-000"
                              name="cep"
                              placeholder="CEP"
                              (change)="consultaCep('servidor')"
                              [class.is-invalid]="erroCampoDadosPessoais('cep')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('cep')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('cep')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("cep") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="tiposlogradouro">
                              Tipo Logradouro
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="tiposLogradouro"
                              name="tiposlogradouro"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Tipo Logradouro"
                              id="tiposlogradouro"
                              [(ngModel)]="endereco.tipo_logradouro"
                              [class.is-invalid]="erroCampoDadosPessoais('tipo_logradouro')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('tipo_logradouro')"
                              [disabled]="!isEditingPersonalData"
                            ></ng-select>
                            <div
                              *ngIf="erroCampoDadosPessoais('tipo_logradouro')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("tipo_logradouro") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="estado">
                              Estado
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="estados"
                              name="estado"
                              (change)="toggleEstadoCep('servidor')"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="Estado"
                              id="estado"
                              [(ngModel)]="endereco.estado"
                              [class.is-invalid]="erroCampoDadosPessoais('estado')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('estado')"
                              [disabled]="!isEditingPersonalData"
                            ></ng-select>
                            <div
                              *ngIf="erroCampoDadosPessoais('estado')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("estado") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cidade">
                              Cidade
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="cidadesEndereco"
                              [disabled]="
                                !isEditingPersonalData ||
                                !cidadesEndereco || cidadesEndereco.length == 0
                              "
                              name="cidade"
                              bindLabel="nome"
                              bindValue="id"
                              placeholder="Cidade"
                              id="cidade"
                              [(ngModel)]="endereco.cidade"
                              [class.is-invalid]="erroCampoDadosPessoais('cidade')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('cidade')"
                            ></ng-select>
                            <div
                              *ngIf="erroCampoDadosPessoais('cidade')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("cidade") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <div class="controls">
                            <label for="logradouro">
                              Logradouro
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="logradouro"
                              class="form-control"
                              [(ngModel)]="endereco.logradouro"
                              name="logradouro"
                              placeholder="Logradouro"
                              [class.is-invalid]="erroCampoDadosPessoais('logradouro')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('logradouro')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('logradouro')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("logradouro") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero">
                              Número
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="numero"
                              class="form-control"
                              [(ngModel)]="endereco.numero"
                              name="numero"
                              placeholder="Número"
                              [class.is-invalid]="erroCampoDadosPessoais('numero')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('numero')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('numero')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("numero") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col">
                        <div class="form-group">
                          <div class="controls">
                            <label for="bairro">
                              Bairro
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="bairro"
                              class="form-control"
                              [(ngModel)]="endereco.bairro"
                              name="bairro"
                              placeholder="Bairro"
                              [class.is-invalid]="erroCampoDadosPessoais('bairro')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('bairro')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('bairro')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("bairro") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <div class="controls">
                            <label for="complemento">
                              Complemento
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="complemento"
                              class="form-control"
                              [(ngModel)]="endereco.complemento"
                              name="complemento"
                              placeholder="Complemento"
                              [class.is-invalid]="erroCampoDadosPessoais('complemento')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('complemento')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('complemento')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("complemento") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Documentos</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cpf">
                              CPF
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="cpf"
                              class="form-control"
                              [(ngModel)]="documentos.cpf"
                              mask="000.000.000-00"
                              name="cpf"
                              placeholder="CPF"
                              [class.is-invalid]="erroCampoDadosPessoais('cpf')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('cpf')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('cpf')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("cpf") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="rg">
                              RG
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="rg"
                              class="form-control"
                              [(ngModel)]="documentos.rg"
                              name="rg"
                              placeholder="RG"
                              [class.is-invalid]="erroCampoDadosPessoais('rg')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('rg')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('rg')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("rg") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_emissao_rg">
                              Emissão RG
                              <span
                                *ngIf="servidor && servidor.status && servidor.status != 1"
                                class="campo-obrigatorio-label"
                              >
                                OBRIGATÓRIO
                              </span>
                            </label>
                            <input
                              type="text"
                              id="data_emissao_rg"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="documentos.data_emissao_rg"
                              name="data_emissao_rg"
                              placeholder="Data Emissão RG"
                              [class.is-invalid]="erroCampoDadosPessoais('data_emissao_rg')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('data_emissao_rg')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('data_emissao_rg')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("data_emissao_rg") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <div class="controls">
                            <label for="orgaosExpedidores">
                              Órgão Expedidor
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="orgaosExpedidores"
                              name="orgaosExpedidores"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Orgão Expedidor RG"
                              id="orgaosExpedidores"
                              [(ngModel)]="documentos.orgao_expedidor_rg"
                              [class.is-invalid]="erroCampoDadosPessoais('orgao_expedidor_rg')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('orgao_expedidor_rg')"
                              [disabled]="!isEditingPersonalData"
                            ></ng-select>
                            <div
                              *ngIf="erroCampoDadosPessoais('orgao_expedidor_rg')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("orgao_expedidor_rg") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="uf_rg">
                              UF RG
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="estados"
                              name="uf_rg"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="UF RG"
                              id="uf_rg"
                              [(ngModel)]="documentos.uf_rg"
                              [class.is-invalid]="erroCampoDadosPessoais('uf_rg')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('uf_rg')"
                              [disabled]="!isEditingPersonalData"
                            ></ng-select>
                            <div
                              *ngIf="erroCampoDadosPessoais('uf_rg')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("uf_rg") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="nit">
                              PIS
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <input
                              type="text"
                              id="nit"
                              class="form-control"
                              [(ngModel)]="documentos.nit"
                              mask="000.00000.00-0"
                              name="nit"
                              placeholder="PIS"
                              [class.is-invalid]="erroCampoDadosPessoais('nit')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('nit')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('nit')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("nit") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Contato</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="telefone">
                              Telefone
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO (AO MENOS UM)</span>
                            </label>
                            <input
                              type="text"
                              id="telefone"
                              class="form-control"
                              [(ngModel)]="contato.telefone"
                              mask="(00) 0000-0000"
                              name="telefone"
                              placeholder="Telefone"
                              [class.is-invalid]="erroCampoDadosPessoais('telefone')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('telefone')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('telefone')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("telefone") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="celular">
                              Celular
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO (AO MENOS UM)</span>
                            </label>
                            <input
                              type="text"
                              id="celular"
                              class="form-control"
                              [(ngModel)]="contato.celular"
                              mask="(00) 00000-0000"
                              name="celular"
                              placeholder="Celular"
                              [class.is-invalid]="erroCampoDadosPessoais('celular')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('celular')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('celular')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("celular") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="email">
                              Email
                              <span class="campo-obrigatorio-label">OBRIGATÓRIO (AO MENOS UM)</span>
                            </label>
                            <input
                              type="text"
                              id="email"
                              class="form-control"
                              [(ngModel)]="contato.email"
                              name="email"
                              placeholder="Email"
                              [class.is-invalid]="erroCampoDadosPessoais('email')"
                              [attr.aria-invalid]="!!erroCampoDadosPessoais('email')"
                              [disabled]="!isEditingPersonalData"
                            />
                            <div
                              *ngIf="erroCampoDadosPessoais('email')"
                              class="invalid-feedback d-block"
                            >
                              {{ erroCampoDadosPessoais("email") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col" *ngIf="!isEditingPersonalData && podeEditarDadosServidor()">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="toggleEditPersonalData()"
                        >
                          Editar
                        </button>
                      </div>

                      <div class="col" *ngIf="isEditingPersonalData">
                        <button
                          type="submit"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                        >
                          {{ salvandoDadosPessoais ? "Salvando..." : "Salvar" }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-primary float-right mr-2"
                          (click)="toggleEditPersonalData(true)"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-tab>

              <ngb-tab title="Pendências">
                <ng-template ngbTabContent>
                  <div class="formulario-validavel formulario-pendencias">
                  <h5 class="text-left mt-2">Pendências e Observações</h5>
                  <div class="form-row">
                    <div class="col-12">
                      <div class="form-group">
                        <div class="controls">
                          <label for="pendencias">Pendências<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                          <textarea
                            maxlength="1000"
                            id="pendencias"
                            class="form-control"
                            [disabled]="!isEditingObservations"
                            [(ngModel)]="servidor.pendencias"
                            name="pendencias"
                            placeholder="Escreva a pendência ou observação do Servidor cadastrado. Documento faltante e/ou busca a ser feita ou confirmada para êxito no cadastro."
                            required
                            [class.is-invalid]="erroCampoFormulario('pendencias', 'pendencias')"
                            [attr.aria-invalid]="!!erroCampoFormulario('pendencias', 'pendencias')"
                          ></textarea>
                          <div *ngIf="erroCampoFormulario('pendencias', 'pendencias')" class="invalid-feedback d-block">
                            {{ erroCampoFormulario("pendencias", "pendencias") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <div class="controls">
                          <label for="observacoes">observações</label>
                          <textarea
                            maxlength="1000"
                            id="observacoes"
                            class="form-control"
                            [disabled]="!isEditingObservations"
                            [(ngModel)]="servidor.observacoes"
                            name="observacoes"
                            placeholder="Observações"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <!-- Botão "Editar" quando isEditingBasicInfos for false -->
                    <div class="col" *ngIf="!isEditingObservations && podeEditarDadosServidor()">
                      <button
                        type="button"
                        class="btn btn-primary mb-2 mb-md-0 float-right"
                        (click)="toggleEditObservations()"
                      >
                        Editar
                      </button>
                    </div>

                    <!-- Botões "Salvar" e "Cancelar" quando isEditingBasicInfos for true -->
                    <div class="col" *ngIf="isEditingObservations">
                      <button
                        type="button"
                        class="btn btn-primary mb-2 mb-md-0 float-right"
                        (click)="salvarPendencias()"
                      >
                        Salvar
                      </button>

                      <button
                        type="button"
                        class="btn btn-outline-primary mb-2 mb-md-0 mr-2 float-right"
                        (click)="toggleEditObservations(true)"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                  </div>
                </ng-template>
              </ngb-tab>

              <ngb-tab title="Óbito" *ngIf="servidor && servidor.status == 3">
                <ng-template ngbTabContent>
                  <form #servForm="ngForm" class="formulario-validavel formulario-obito" novalidate>
                    <h5 class="text-left mt-2">Dados do Cartório</h5>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="nome_cartorio">Nome Cartório<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="nome_cartorio"
                              class="form-control"
                              [(ngModel)]="obito.nome_cartorio"
                              name="nome_cartorio"
                              placeholder="Nome Cartório"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'nome_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'nome_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'nome_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "nome_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cnpj_cartorio">CNPJ</label>
                            <input
                              type="text"
                              id="cnpj_cartorio"
                              class="form-control"
                              [(ngModel)]="obito.cnpj_cartorio"
                              name="cnpj_cartorio"
                              placeholder="CNPJ"
                              required
                              aria-invalid="false"
                              [disabled]="!isEditingObito"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cep">CEP<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="cep"
                              class="form-control"
                              [(ngModel)]="obito.cep_cartorio"
                              mask="00.000-000"
                              name="cep"
                              placeholder="CEP"
                              (change)="consultaCep('obito')"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'cep_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'cep_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'cep_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "cep_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="tiposlogradouro">Tipo Logradouro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="tiposLogradouro"
                              name="tiposlogradouro"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Tipo Logradouro"
                              id="tiposlogradouro"
                              [(ngModel)]="obito.tipo_logradouro_cartorio"
                              [class.is-invalid]="erroCampoFormulario('obito', 'tipo_logradouro_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'tipo_logradouro_cartorio')"
                              [disabled]="!isEditingObito"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('obito', 'tipo_logradouro_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "tipo_logradouro_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="logradouro">Logradouro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="logradouro"
                              class="form-control"
                              [(ngModel)]="obito.logradouro_cartorio"
                              name="logradouro"
                              placeholder="Logradouro"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'logradouro_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'logradouro_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'logradouro_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "logradouro_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero">Número<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="numero"
                              class="form-control"
                              [(ngModel)]="obito.numero_cartorio"
                              name="numero"
                              placeholder="Número"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'numero_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'numero_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'numero_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "numero_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="estado">Estado<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="estados"
                              name="estado"
                              (change)="toggleEstadoCep('obito')"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="Estado"
                              id="estado"
                              [(ngModel)]="obito.estado_cartorio"
                              [class.is-invalid]="erroCampoFormulario('obito', 'estado_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'estado_cartorio')"
                              [disabled]="!isEditingObito"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('obito', 'estado_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "estado_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cidade">Cidade<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="cidadesObito"
                              [disabled]="
                                !cidadesObito || cidadesObito.length == 0
                              "
                              name="cidade"
                              bindLabel="nome"
                              bindValue="id"
                              placeholder="Cidade"
                              id="cidade"
                              [(ngModel)]="obito.cidade_cartorio"
                              [class.is-invalid]="erroCampoFormulario('obito', 'cidade_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'cidade_cartorio')"
                              [disabled]="!isEditingObito"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('obito', 'cidade_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "cidade_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="bairro">Bairro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="bairro"
                              class="form-control"
                              [(ngModel)]="obito.bairro_cartorio"
                              name="bairro"
                              placeholder="Bairro"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'bairro_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'bairro_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'bairro_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "bairro_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="complemento">Complemento<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="complemento"
                              class="form-control"
                              [(ngModel)]="obito.complemento_cartorio"
                              name="complemento"
                              placeholder="Complemento"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'complemento_cartorio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'complemento_cartorio')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'complemento_cartorio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "complemento_cartorio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="text-left mt-2">Dados da Certidão</h5>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_emissao">Data de Emissão<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="data_emissao"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="obito.data_emissao"
                              name="data_emissao"
                              placeholder="Data de Emissão"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'data_emissao')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'data_emissao')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'data_emissao')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "data_emissao") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero_termo">Número Termo<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="numero_termo"
                              class="form-control"
                              [(ngModel)]="obito.numero_termo"
                              name="numero_termo"
                              placeholder="Número Termo"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'numero_termo')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'numero_termo')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'numero_termo')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "numero_termo") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero_livro">Número Livro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="numero_livro"
                              class="form-control"
                              [(ngModel)]="obito.numero_livro"
                              name="numero_livro"
                              placeholder="Número Livro"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'numero_livro')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'numero_livro')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'numero_livro')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "numero_livro") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero_folha">Número Folha<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="numero_folha"
                              class="form-control"
                              [(ngModel)]="obito.numero_folha"
                              name="numero_folha"
                              placeholder="Número Folha"
                              required
                              [class.is-invalid]="erroCampoFormulario('obito', 'numero_folha')"
                              [attr.aria-invalid]="!!erroCampoFormulario('obito', 'numero_folha')"
                              [disabled]="!isEditingObito"
                            />
                            <div *ngIf="erroCampoFormulario('obito', 'numero_folha')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("obito", "numero_folha") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Botão "Editar" quando isEditingBasicInfos for false -->
                      <div class="col" *ngIf="!isEditingObito && podeEditarDadosServidor()">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="toggleEditObito()"
                        >
                          Editar
                        </button>
                      </div>

                      <!-- Botões "Salvar" e "Cancelar" quando isEditingBasicInfos for true -->
                      <div class="col" *ngIf="isEditingObito">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="atualizarOuCadastrarObito()"
                        >
                          {{ obito.id ? "Atualizar" : "Cadastrar" }}
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-primary mb-2 mb-md-0 mr-2 float-right"
                          (click)="toggleEditObito(true)"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-tab>

              <ngb-tab title="Representante Legal">
                <ng-template ngbTabContent>
                  <form #servForm="ngForm" class="formulario-validavel formulario-representante" novalidate>
                    <h5 class="text-left mt-2">Dados do Representante</h5>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="tipo_representatividade">
                              Tipo Representatividade<span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="tiposRepresentatividade"
                              name="tipo_representatividade"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Tipo Representatividade"
                              id="tipo_representatividade"
                              [(ngModel)]="
                                representante.tipo_representatividade
                              "
                              [class.is-invalid]="erroCampoFormulario('representante', 'tipo_representatividade')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'tipo_representatividade')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'tipo_representatividade')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "tipo_representatividade") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_inicio">Início<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="data_inicio"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="representante.data_inicio"
                              name="data_inicio"
                              placeholder="Data Início"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'data_inicio')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'data_inicio')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'data_inicio')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "data_inicio") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_fim">Fim<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="data_fim"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="representante.data_fim"
                              name="data_fim"
                              placeholder="Data Fim"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'data_fim')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'data_fim')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'data_fim')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "data_fim") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="nome">Nome<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="nome"
                              class="form-control"
                              [(ngModel)]="representante.nome_representante"
                              name="nome"
                              placeholder="Nome Completo"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'nome_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'nome_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'nome_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "nome_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="sexo">Sexo<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="sexos"
                              name="sexo"
                              bindLabel="name"
                              placeholder="Sexo"
                              bindValue="id"
                              id="sexo"
                              [(ngModel)]="representante.sexo_representante"
                              [class.is-invalid]="erroCampoFormulario('representante', 'sexo_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'sexo_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'sexo_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "sexo_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_nascimento">Nascimento<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="data_nascimento"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="
                                representante.data_nascimento_representante
                              "
                              name="data_nascimento"
                              placeholder="Data Nascimento"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'data_nascimento_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'data_nascimento_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'data_nascimento_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "data_nascimento_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <h5 class="text-left mt-2">Documentos</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cpf">CPF<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="cpf"
                              class="form-control"
                              [(ngModel)]="representante.cpf_representante"
                              mask="000.000.000-00"
                              name="cpf"
                              placeholder="CPF"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'cpf_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'cpf_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'cpf_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "cpf_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="rg">RG<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="rg"
                              class="form-control"
                              [(ngModel)]="representante.rg_representante"
                              name="rg"
                              placeholder="RG"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'rg_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'rg_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'rg_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "rg_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="data_emissao_rg">Emissão RG<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="data_emissao_rg"
                              class="form-control"
                              mask="00/00/0000"
                              [(ngModel)]="
                                representante.data_emissao_rg_representante
                              "
                              name="data_emissao_rg"
                              placeholder="Data Emissão RG"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'data_emissao_rg_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'data_emissao_rg_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'data_emissao_rg_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "data_emissao_rg_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="orgaosExpedidores">
                              Órgão Expedidor RG<span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                            </label>
                            <ng-select
                              [items]="orgaosExpedidores"
                              name="orgaosExpedidores"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Orgão Expedidor RG"
                              id="orgaosExpedidores"
                              [(ngModel)]="
                                representante.orgao_expedidor_rg_representante
                              "
                              [class.is-invalid]="erroCampoFormulario('representante', 'orgao_expedidor_rg_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'orgao_expedidor_rg_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'orgao_expedidor_rg_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "orgao_expedidor_rg_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="uf_rg">Unidade Federal RG<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="estados"
                              name="uf_rg"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="UF RG"
                              id="uf_rg"
                              [(ngModel)]="representante.uf_rg_representante"
                              [class.is-invalid]="erroCampoFormulario('representante', 'uf_rg_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'uf_rg_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'uf_rg_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "uf_rg_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Endereço</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cep">CEP<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="cep"
                              class="form-control"
                              [(ngModel)]="representante.cep_representante"
                              mask="00.000-000"
                              name="cep"
                              placeholder="CEP"
                              (change)="consultaCep('representante')"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'cep_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'cep_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'cep_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "cep_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="tiposlogradouro">Tipo Logradouro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="tiposLogradouro"
                              name="tiposlogradouro"
                              bindLabel="descricao"
                              bindValue="id"
                              placeholder="Tipo Logradouro"
                              id="tiposlogradouro"
                              [(ngModel)]="
                                representante.tipo_logradouro_representante
                              "
                              [class.is-invalid]="erroCampoFormulario('representante', 'tipo_logradouro_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'tipo_logradouro_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'tipo_logradouro_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "tipo_logradouro_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="logradouro">Logradouro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="logradouro"
                              class="form-control"
                              [(ngModel)]="
                                representante.logradouro_representante
                              "
                              name="logradouro"
                              placeholder="Logradouro"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'logradouro_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'logradouro_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'logradouro_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "logradouro_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="numero">Número<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="numero"
                              class="form-control"
                              [(ngModel)]="representante.numero_representante"
                              name="numero"
                              placeholder="Número"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'numero_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'numero_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'numero_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "numero_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="estado">Estado<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="estados"
                              name="estado"
                              (change)="toggleEstadoCep('representante')"
                              bindLabel="estado"
                              bindValue="estado"
                              placeholder="Estado"
                              id="estado"
                              [(ngModel)]="representante.estado_representante"
                              [class.is-invalid]="erroCampoFormulario('representante', 'estado_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'estado_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'estado_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "estado_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="cidade">Cidade<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <ng-select
                              [items]="cidadesRepresentante"
                              [disabled]="
                                !cidadesRepresentante ||
                                cidadesRepresentante.length == 0
                              "
                              name="cidade"
                              bindLabel="nome"
                              bindValue="id"
                              placeholder="Cidade"
                              id="cidade"
                              [(ngModel)]="representante.cidade_representante"
                              [class.is-invalid]="erroCampoFormulario('representante', 'cidade_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'cidade_representante')"
                              [disabled]="!isEditingRepresentante"
                            ></ng-select>
                            <div *ngIf="erroCampoFormulario('representante', 'cidade_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "cidade_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="bairro">Bairro<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="bairro"
                              class="form-control"
                              [(ngModel)]="representante.bairro_representante"
                              name="bairro"
                              placeholder="Bairro"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'bairro_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'bairro_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'bairro_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "bairro_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="complemento">Complemento<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                            <input
                              type="text"
                              id="complemento"
                              class="form-control"
                              [(ngModel)]="
                                representante.complemento_representante
                              "
                              name="complemento"
                              placeholder="Complemento"
                              required
                              [class.is-invalid]="erroCampoFormulario('representante', 'complemento_representante')"
                              [attr.aria-invalid]="!!erroCampoFormulario('representante', 'complemento_representante')"
                              [disabled]="!isEditingRepresentante"
                            />
                            <div *ngIf="erroCampoFormulario('representante', 'complemento_representante')" class="invalid-feedback d-block">
                              {{ erroCampoFormulario("representante", "complemento_representante") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <h5 class="text-left mt-2">Contato</h5>

                    <div class="form-row">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="telefone">Telefone</label>
                            <input
                              type="text"
                              id="telefone"
                              class="form-control"
                              [(ngModel)]="representante.telefone_representante"
                              mask="(00) 0000-0000"
                              name="telefone"
                              placeholder="Telefone"
                              required
                              aria-invalid="false"
                              [disabled]="!isEditingRepresentante"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <div class="controls">
                            <label for="celular">Celular</label>
                            <input
                              type="text"
                              id="celular"
                              class="form-control"
                              [(ngModel)]="representante.celular_representante"
                              mask="(00) 00000-0000"
                              name="celular"
                              placeholder="Celular"
                              required
                              aria-invalid="false"
                              [disabled]="!isEditingRepresentante"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="controls">
                            <label for="email">Email</label>
                            <input
                              type="text"
                              id="email"
                              class="form-control"
                              [(ngModel)]="representante.email_representante"
                              name="email"
                              placeholder="Email"
                              required
                              aria-invalid="false"
                              [disabled]="!isEditingRepresentante"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Botão "Editar" quando isEditingBasicInfos for false -->
                      <div class="col" *ngIf="!isEditingRepresentante && podeEditarDadosServidor()">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="toggleEditRepresentante()"
                        >
                          Editar
                        </button>
                      </div>

                      <!-- Botões "Salvar" e "Cancelar" quando isEditingBasicInfos for true -->
                      <div class="col" *ngIf="isEditingRepresentante">
                        <button
                          type="button"
                          class="btn btn-primary mb-2 mb-md-0 float-right"
                          (click)="atualizarOuCadastrarRepresentante()"
                        >
                          {{ representante.id ? "Atualizar" : "Cadastrar" }}
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-primary mb-2 mb-md-0 mr-2 float-right"
                          (click)="toggleEditRepresentante(true)"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-tab>
            </ngb-tabset>
          </div>
        </div>
      </div>

      <div class="attachments-info">
        <div class="card">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-header-leading">
              <div class="card-title-group">
                <h4>Documentos Anexos</h4>
                <span>Documentos do servidor</span>
              </div>
              <label class="conferencia-check" [class.conferido]="conferenciaBlocos.anexos" *ngIf="isConferidor && !modoSomenteLeitura">
                <input
                  type="checkbox"
                  [(ngModel)]="conferenciaBlocos.anexos"
                  [ngModelOptions]="{ standalone: true }"
                />
                Conferido?
              </label>
            </div>
            <div class="card-header-actions">
              <button class="btn-no-border" (click)="toggleAttachmentsData()">
                {{ isAttachmentsDataVisible ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
          </div>

          <div class="card-body" *ngIf="isAttachmentsDataVisible">
            <div *ngIf="anexos && anexos.length === 0" class="no-benefits">
              <!-- Mensagem de orientação -->
              <p class="text-muted text-center" *ngIf="!modoSomenteLeitura">
                Adicione um novo item clicando no botão <i>"Adicionar"</i>
              </p>
              <p class="text-muted text-center" *ngIf="modoSomenteLeitura">
                Nenhum documento anexado.
              </p>
            </div>

            <div
              *ngFor="let anexo of anexos; let i = index"
              [ngClass]="{
                'custom-card': true,
                'single-card': anexos.length === 1,
                'mt-0': i !== 0,
                'first-card': i === 0,
                'last-card': i === anexos.length - 1
              }"
            >
              <div class="card-body">
                <!-- Título -->
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="card-title text-start">
                    {{ anexo.referencia }}
                  </h5>
                </div>

                <div class="row">
                  <!-- Informações da Remuneração -->
                  <div class="col-8 card-text mt-2">
                    <p>
                      Nome:
                      {{ anexo.nome }}
                    </p>
                    <p>
                      Importado em:
                      {{ beautifulDateSimple(anexo.data_inclusao) }}
                    </p>
                  </div>

                  <!-- Botões de Ação -->
                  <div
                    class="col-4 actions d-flex justify-content-end align-items-end"
                  >
                    <button
                      class="btn btn-outline-danger"
                      (click)="deleteAttachment(anexo.chave, anexo.id)"
                      *ngIf="!modoSomenteLeitura"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      class="btn btn-outline-success"
                      (click)="downloadAttachment(anexo.chave, anexo.nome)"
                    >
                      <i class="fa fa-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end align-items-end mb-3 mt-3" *ngIf="!modoSomenteLeitura">
              <button
                class="btn btn-primary"
                (click)="openModalLg(cadastroAnexo)"
              >
                Adicionar Documento
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="dependents-info">
        <div class="card" *ngIf="servidor">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-header-leading">
              <div class="card-title-group">
                <h4>Dependentes</h4>
                <span>Vinculados ao CPF</span>
              </div>
              <label class="conferencia-check" [class.conferido]="conferenciaBlocos.dependentes" *ngIf="isConferidor && !modoSomenteLeitura && !isPensionistaPuro()">
                <input
                  type="checkbox"
                  [(ngModel)]="conferenciaBlocos.dependentes"
                  [ngModelOptions]="{ standalone: true }"
                />
                Conferido?
              </label>
            </div>
            <div class="card-header-actions">
              <button class="btn-no-border" (click)="toggleDependentsData()">
                {{ isDependentsDataVisible ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
          </div>

          <div class="card-body" *ngIf="isDependentsDataVisible">
            <div class="regra-nao-aplica" *ngIf="isPensionistaPuro()">
              <i class="ft-info regra-nao-aplica-icone"></i>
              <div>
                <h6>Ocultado — pensionista puro</h6>
                <p>Dependentes não são exibidos quando o servidor possui somente matrícula de pensionista.</p>
              </div>
            </div>
            <div
              *ngIf="!isPensionistaPuro() && dependentes && dependentes.length === 0"
              class="no-benefits"
            >
              <!-- Mensagem de orientação -->
              <p class="text-muted text-center" *ngIf="!modoSomenteLeitura">
                Adicione um novo item clicando no botão <i>"Adicionar"</i>
              </p>
              <p class="text-muted text-center" *ngIf="modoSomenteLeitura">
                Nenhum dependente cadastrado.
              </p>
            </div>

            <div
              *ngFor="let dependente of dependentes; let i = index"
              [hidden]="isPensionistaPuro()"
              [ngClass]="{
                'custom-card': true,
                'single-card': dependentes.length === 1,
                'mt-0': i !== 0,
                'first-card': i === 0,
                'last-card': i === dependentes.length - 1
              }"
            >
              <div class="card-body">
                <!-- Título -->
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="card-title text-start">
                    {{ dependente.nome }}
                  </h5>
                </div>

                <div class="row">
                  <!-- Informações da Remuneração -->
                  <div class="col-8 card-text mt-2">
                    <p>
                      <b>Relação:</b>
                      {{ dependente.labelRelacao }}
                    </p>
                    <p>
                      <b>CPF:</b>
                      {{
                        dependente && dependente.cpf
                          ? (dependente?.cpf | mask : "000.000.000-00")
                          : "-----"
                      }}
                    </p>
                    <p>
                      <b>Idade:</b>
                      {{ dependente.idade }} anos
                    </p>
                  </div>

                  <!-- Botões de Ação -->
                  <div
                    class="col-4 actions d-flex justify-content-end align-items-end"
                  >
                    <button
                      *ngIf="!modoSomenteLeitura"
                      class="btn btn-outline-danger"
                      (click)="deletarDependente(dependente.id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      class="btn btn-outline-success"
                      (click)="
                        openModalDependent(cadastroDependente, dependente)
                      "
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end align-items-end mb-3 mt-3" *ngIf="!modoSomenteLeitura && !isPensionistaPuro()">
              <button
                class="btn btn-primary"
                (click)="openModalDependent(cadastroDependente, null)"
              >
                Adicionar Dependente
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="matriculas-movimentos" class="matricula-info" *ngIf="servidor">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="card-header-leading">
              <div class="card-title-group">
                <h4>Matrículas &amp; Movimentos</h4>
                <span>Dados funcionais organizados por matrícula resumidos</span>
              </div>
              <label class="conferencia-check" [class.conferido]="getMatriculaConferida()" *ngIf="isConferidor && !modoSomenteLeitura && !isMatriculaTemporaria()">
                <input
                  type="checkbox"
                  [ngModel]="getMatriculaConferida()"
                  (ngModelChange)="setMatriculaConferida($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
                Conferido?
              </label>
            </div>
            <div class="card-header-actions">
              <button
                type="button"
                class="btn btn-sm btn-outline-danger mr-2"
                *ngIf="isConferidor && podeExcluirMatricula && matriculaSelecionada && !isMatriculaTemporaria()"
                [disabled]="excluindoMatricula"
                (click)="excluirMatriculaSelecionada()"
              >
                <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                {{ excluindoMatricula ? 'Excluindo...' : 'Excluir matrícula' }}
              </button>
              <button class="btn-no-border" (click)="toggleMatriculaData()">
                {{ isMatriculaDataVisible ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
          </div>

          <div *ngIf="isMatriculaDataVisible">
            <div class="card-body matricula-gerais">
              <div class="section-heading">
                <h5>Dados Funcionais Gerais</h5>
              </div>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label>Data de Ingresso no Serviço Público</label>
                  <div class="form-control matricula-readonly">{{ formatarDataMatricula(servidor.data_ingresso_servico_publico) }}</div>
                </div>
                <div class="col-md-6 form-group">
                  <label>Data de Ingresso no Ente (RPPS)</label>
                  <div class="form-control matricula-readonly">{{ formatarDataMatricula(servidor.data_ingresso_ente) }}</div>
                </div>
                <div class="col-md-6 form-group">
                  <label>Primeiro Emprego</label>
                  <div class="form-control matricula-readonly">{{ servidor.emprego_carteira || '---' }}</div>
                </div>
                <div class="col-md-6 form-group">
                  <label>Data de Ingresso no Primeiro Emprego</label>
                  <div class="form-control matricula-readonly">{{ formatarDataMatricula(servidor.data_ingresso_carteira) }}</div>
                </div>
              </div>
            </div>

            <div class="matricula-tabs">
              <button
                type="button"
                class="matricula-tab"
                *ngFor="let matricula of getMatriculasServidor()"
                [class.active]="isMatriculaSelecionada(matricula)"
                (click)="selecionarMatricula(matricula)"
              >
                <span class="status-servidor status-sm" [ngClass]="getStatusClass(matricula.status)">
                  {{ getStatus(matricula.status) }}
                </span>
                <span>{{ isMatriculaTemporaria(matricula) ? 'Sem matrícula' : 'Nº ' + matricula.matricula }}</span>
                <span class="badge badge-warning ml-1" *ngIf="isMatriculaTemporaria(matricula)">Temporária</span>
              </button>
              <button type="button" class="matricula-tab adicionar" (click)="openModalMatricula(cadastroMatricula)" *ngIf="!modoSomenteLeitura">
                <i class="fa fa-plus mr-1"></i>Adicionar matrícula
              </button>
            </div>

            <div class="regra-nao-aplica mx-3 mb-3" *ngIf="!getMatriculasServidor().length">
              <i class="ft-info regra-nao-aplica-icone"></i>
              <div>
                <h6>Nenhuma matrícula cadastrada</h6>
                <p>
                  {{ modoSomenteLeitura
                    ? 'Não há detalhes ou movimentos funcionais para exibir.'
                    : 'Cadastre a primeira matrícula para visualizar os detalhes e movimentos funcionais.' }}
                </p>
              </div>
            </div>

            <div class="regra-nao-aplica mx-3 mb-3" *ngIf="isMatriculaTemporaria()">
              <i class="ft-info regra-nao-aplica-icone"></i>
              <div>
                <h6>Aguardando matrícula real</h6>
                <p>
                  Este vínculo temporário não recebe movimentos, atendimento ou tempo de serviço.
                  Use <strong>Adicionar matrícula</strong> para informar a matrícula real.
                </p>
              </div>
            </div>

            <div class="card-body" *ngIf="matriculaSelecionada && !isMatriculaTemporaria()">
              <h5>Detalhes da Matrícula</h5>
              <div class="form-row mt-2">
                <div class="col-md-4 form-group">
                  <label>Status da Matrícula</label>
                  <div class="matricula-status-field" *ngIf="!editandoStatusMatricula">
                    <span class="status-servidor" [ngClass]="getStatusClass(matriculaSelecionada.status)">
                      {{ getStatus(matriculaSelecionada.status) }}
                    </span>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary ml-2"
                      (click)="iniciarEdicaoStatusMatricula()"
                      *ngIf="podeEditarMatriculaSelecionada()"
                    >
                      Alterar
                    </button>
                  </div>
                  <div class="matricula-status-editor" *ngIf="editandoStatusMatricula">
                    <ng-select
                      [items]="statusServidor"
                      bindLabel="name"
                      bindValue="id"
                      [clearable]="false"
                      [searchable]="false"
                      [(ngModel)]="statusMatriculaEmEdicao"
                      [ngModelOptions]="{ standalone: true }"
                      aria-label="Novo status da matrícula"
                    ></ng-select>
                    <div class="matricula-status-actions">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        [disabled]="salvandoStatusMatricula"
                        (click)="salvarStatusMatricula()"
                      >
                        {{ salvandoStatusMatricula ? 'Salvando...' : 'Salvar' }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        [disabled]="salvandoStatusMatricula"
                        (click)="cancelarEdicaoStatusMatricula()"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label>Estado da Matrícula</label>
                  <div class="form-control matricula-readonly">{{ getEstadoMatricula(matriculaSelecionada) }}</div>
                </div>
                <div class="col-md-4 form-group">
                  <label>Município</label>
                  <div class="form-control matricula-readonly">{{ getMunicipioMatricula(matriculaSelecionada) }}</div>
                </div>
              </div>

              <div
                class="d-flex justify-content-end mb-2"
                *ngIf="podeEditarDadosMatricula() && !editandoDadosBeneficioMatricula"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="iniciarEdicaoDadosBeneficioMatricula()"
                >
                  <i class="fa fa-pencil mr-1"></i>Editar dados da matrícula
                </button>
              </div>

              <ng-container *ngIf="!editandoDadosBeneficioMatricula">
                <ng-container *ngFor="let secao of getSecoesDetalhesMatricula()">
                  <div class="matricula-detalhe-subtitulo">{{ secao.titulo }}</div>
                  <div class="form-row">
                    <div class="col-md-3 form-group" *ngFor="let campo of secao.campos">
                      <label>{{ campo.label }}</label>
                      <div class="form-control matricula-readonly">{{ campo.valor }}</div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <div
                class="matricula-beneficio-editor formulario-validavel formulario-beneficio-matricula"
                *ngIf="editandoDadosBeneficioMatricula && dadosBeneficioMatricula"
              >
                <div class="matricula-detalhe-subtitulo">
                  Editar dados da matrícula
                </div>

                <div class="form-row">
                  <div class="col-md-3 form-group">
                    <label for="matricula-beneficio-numero">
                      {{ matriculaSelecionada.status == 3 ? 'Matrícula do Beneficiário' : 'Matrícula' }}
                      <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                    </label>
                    <input
                      type="text"
                      id="matricula-beneficio-numero"
                      class="form-control"
                      [(ngModel)]="dadosBeneficioMatricula.matricula"
                      [ngModelOptions]="{ standalone: true }"
                      [class.is-invalid]="erroCampoFormulario('beneficio-matricula', 'matricula')"
                      [attr.aria-invalid]="!!erroCampoFormulario('beneficio-matricula', 'matricula')"
                      placeholder="Número da matrícula"
                      required
                    />
                    <div *ngIf="erroCampoFormulario('beneficio-matricula', 'matricula')" class="invalid-feedback d-block">
                      {{ erroCampoFormulario("beneficio-matricula", "matricula") }}
                    </div>
                  </div>
                  <div class="col-md-3 form-group">
                    <label for="matricula-beneficio-orgao">
                      Órgão
                      <span *ngIf="matriculaSelecionada.status == 2" class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                    </label>
                    <ng-select
                      id="matricula-beneficio-orgao"
                      [items]="orgaos"
                      bindLabel="descricao"
                      bindValue="id"
                      [clearable]="true"
                      [(ngModel)]="dadosBeneficioMatricula.orgao"
                      [ngModelOptions]="{ standalone: true }"
                      [class.is-invalid]="erroCampoFormulario('beneficio-matricula', 'orgao')"
                      [attr.aria-invalid]="!!erroCampoFormulario('beneficio-matricula', 'orgao')"
                      placeholder="Órgão"
                    ></ng-select>
                    <div *ngIf="erroCampoFormulario('beneficio-matricula', 'orgao')" class="invalid-feedback d-block">
                      {{ erroCampoFormulario("beneficio-matricula", "orgao") }}
                    </div>
                  </div>
                  <div class="col-md-3 form-group" *ngIf="isStatusBeneficioMatricula()">
                    <label for="matricula-beneficio-concessao">Data de Concessão do Benefício</label>
                    <input
                      type="text"
                      id="matricula-beneficio-concessao"
                      class="form-control"
                      mask="00/00/0000"
                      [(ngModel)]="dadosBeneficioMatricula.concessao_aposentadoria"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Data de Concessão"
                    />
                  </div>
                  <div class="col-md-3 form-group" *ngIf="isStatusBeneficioMatricula()">
                    <label for="matricula-beneficio-fundo">
                      Tipo de Fundo <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                    </label>
                    <ng-select
                      id="matricula-beneficio-fundo"
                      [items]="tipoFundo"
                      [clearable]="true"
                      [(ngModel)]="dadosBeneficioMatricula.tipo_fundo"
                      [ngModelOptions]="{ standalone: true }"
                      [class.is-invalid]="erroCampoFormulario('beneficio-matricula', 'tipo_fundo')"
                      [attr.aria-invalid]="!!erroCampoFormulario('beneficio-matricula', 'tipo_fundo')"
                      placeholder="Tipo de Fundo"
                    ></ng-select>
                    <div *ngIf="erroCampoFormulario('beneficio-matricula', 'tipo_fundo')" class="invalid-feedback d-block">
                      {{ erroCampoFormulario("beneficio-matricula", "tipo_fundo") }}
                    </div>
                  </div>
                  <div class="col-md-3 form-group" *ngIf="isStatusBeneficioMatricula()">
                    <label for="matricula-beneficio-paridade">Paridade</label>
                    <ng-select
                      id="matricula-beneficio-paridade"
                      [items]="naturalizados"
                      bindLabel="name"
                      bindValue="id"
                      [clearable]="true"
                      [(ngModel)]="dadosBeneficioMatricula.paridade_aposentadoria"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Paridade"
                    ></ng-select>
                  </div>
                </div>

                <ng-container *ngIf="matriculaSelecionada.status == 1">
                  <div class="matricula-detalhe-subtitulo">Dados do Vínculo</div>
                  <div class="form-row">
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-tipo">Tipo de Vínculo</label>
                      <input
                        type="text"
                        id="matricula-vinculo-tipo"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.tipo_vinculo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Tipo de Vínculo"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-nomeacao">Data de Nomeação</label>
                      <input
                        type="text"
                        id="matricula-vinculo-nomeacao"
                        class="form-control"
                        mask="00/00/0000"
                        [(ngModel)]="dadosBeneficioMatricula.data_nomeacao"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Data de Nomeação"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-decreto">Decreto</label>
                      <input
                        type="text"
                        id="matricula-vinculo-decreto"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.decreto_nomeacao"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Decreto"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-regime">Regime Previdenciário</label>
                      <ng-select
                        id="matricula-vinculo-regime"
                        [items]="regimesPrevidenciarios"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.regime_previdenciario"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Regime Previdenciário"
                      ></ng-select>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-cargo">Cargo Atual</label>
                      <input
                        type="text"
                        id="matricula-vinculo-cargo"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.cargo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Cargo Atual"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-carga-horaria">Carga Horária</label>
                      <ng-select
                        id="matricula-vinculo-carga-horaria"
                        [items]="cargasHorarias"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.carga_horaria"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Carga Horária"
                      ></ng-select>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-vinculo-situacao">Situação Funcional</label>
                      <ng-select
                        id="matricula-vinculo-situacao"
                        [items]="situacoesFuncionais"
                        bindLabel="name"
                        bindValue="id"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.situacao_funcional"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Situação Funcional"
                      ></ng-select>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="matriculaSelecionada.status == 4">
                  <div class="matricula-detalhe-subtitulo">Exoneração</div>
                  <div class="form-row">
                    <div class="col-md-3 form-group">
                      <label for="matricula-exoneracao-motivo">Motivo da Exoneração</label>
                      <ng-select
                        id="matricula-exoneracao-motivo"
                        [items]="exoneracoes"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.tipo_exoneracao"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Motivo da Exoneração"
                      ></ng-select>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-exoneracao-data">Data da Exoneração</label>
                      <input
                        type="text"
                        id="matricula-exoneracao-data"
                        class="form-control"
                        mask="00/00/0000"
                        [(ngModel)]="dadosBeneficioMatricula.data_saida"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Data da Exoneração"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-exoneracao-cargo">Cargo Exonerado</label>
                      <input
                        type="text"
                        id="matricula-exoneracao-cargo"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.cargo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Cargo Exonerado"
                      />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-exoneracao-nomeacao">Data de Nomeação</label>
                      <input
                        type="text"
                        id="matricula-exoneracao-nomeacao"
                        class="form-control"
                        mask="00/00/0000"
                        [(ngModel)]="dadosBeneficioMatricula.data_nomeacao"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Data de Nomeação"
                      />
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="matriculaSelecionada.status == 2">
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-tipo-aposentadoria">Tipo de Aposentadoria</label>
                      <ng-select
                        id="matricula-beneficio-tipo-aposentadoria"
                        [items]="tiposaposentadoria"
                        bindLabel="name"
                        bindValue="value"
                        groupBy="group"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.tipo_aposentadoria"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Tipo de Aposentadoria"
                      ></ng-select>
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-cargo">Cargo Aposentado</label>
                      <input
                        type="text"
                        id="matricula-beneficio-cargo"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.cargo_aposentadoria"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Cargo em que se aposentou"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-valor-aposentadoria">Valor Atual da Aposentadoria</label>
                      <input
                        type="text"
                        id="matricula-beneficio-valor-aposentadoria"
                        class="form-control"
                        prefix="R$"
                        mask="separator.2"
                        thousandSeparator="."
                        decimalMarker=","
                        [dropSpecialCharacters]="false"
                        [(ngModel)]="dadosBeneficioMatricula.valor_aposentadoria"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Valor Atual"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-pis-aposentado">PIS do Aposentado</label>
                      <input
                        type="text"
                        id="matricula-beneficio-pis-aposentado"
                        class="form-control"
                        mask="0*"
                        [(ngModel)]="dadosBeneficioMatricula.pis_aposentado"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="PIS do Aposentado"
                      />
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="matriculaSelecionada.status == 3">
                  <div class="matricula-detalhe-subtitulo">Dados da Pensão</div>
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-valor-pensao">Valor do Benefício</label>
                      <input
                        type="text"
                        id="matricula-beneficio-valor-pensao"
                        class="form-control"
                        prefix="R$"
                        mask="separator.2"
                        thousandSeparator="."
                        decimalMarker=","
                        [dropSpecialCharacters]="false"
                        [(ngModel)]="dadosBeneficioMatricula.valor_beneficio"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Valor do Benefício"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-tipo-pensao">Tipo de Pensão</label>
                      <ng-select
                        id="matricula-beneficio-tipo-pensao"
                        [items]="tipospensao"
                        bindLabel="name"
                        bindValue="value"
                        [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.tipo_pensao"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Tipo de Pensão"
                      ></ng-select>
                    </div>
                  </div>

                  <div class="matricula-detalhe-subtitulo">Instituidor da Pensão</div>
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-nome-instituidor">
                        Nome do Instituidor <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                      </label>
                      <input
                        type="text"
                        id="matricula-beneficio-nome-instituidor"
                        class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.nome_pensao"
                        [ngModelOptions]="{ standalone: true }"
                        [class.is-invalid]="erroCampoFormulario('beneficio-matricula', 'nome_pensao')"
                        [attr.aria-invalid]="!!erroCampoFormulario('beneficio-matricula', 'nome_pensao')"
                        required
                      />
                      <div *ngIf="erroCampoFormulario('beneficio-matricula', 'nome_pensao')" class="invalid-feedback d-block">
                        {{ erroCampoFormulario("beneficio-matricula", "nome_pensao") }}
                      </div>
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-relacao">Relação com o Titular</label>
                      <ng-select id="matricula-beneficio-relacao" [items]="relacaoTitularPensao"
                        bindLabel="name" bindValue="id" [clearable]="true"
                        [(ngModel)]="dadosBeneficioMatricula.relacao_titular_pensao"
                        [ngModelOptions]="{ standalone: true }"></ng-select>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-beneficio-nascimento-instituidor">Nascimento</label>
                      <input type="text" id="matricula-beneficio-nascimento-instituidor" class="form-control"
                        mask="00/00/0000" [(ngModel)]="dadosBeneficioMatricula.data_nascimento_pensao"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="matricula-beneficio-falecimento-instituidor">Falecimento</label>
                      <input type="text" id="matricula-beneficio-falecimento-instituidor" class="form-control"
                        mask="00/00/0000" [(ngModel)]="dadosBeneficioMatricula.data_falecimento_pensao"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-matricula-instituidor">Matrícula do Instituidor</label>
                      <input type="text" id="matricula-beneficio-matricula-instituidor" class="form-control"
                        [(ngModel)]="dadosBeneficioMatricula.matricula_pensao" [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-pis-instituidor">PIS do Instituidor</label>
                      <input type="text" id="matricula-beneficio-pis-instituidor" class="form-control" mask="0*"
                        [(ngModel)]="dadosBeneficioMatricula.pis_pensao" [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="matricula-beneficio-cpf-instituidor">
                        CPF do Instituidor <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
                      </label>
                      <input
                        type="text"
                        id="matricula-beneficio-cpf-instituidor"
                        class="form-control"
                        mask="000.000.000-00"
                        [(ngModel)]="dadosBeneficioMatricula.cpf_pensao"
                        [ngModelOptions]="{ standalone: true }"
                        [class.is-invalid]="erroCampoFormulario('beneficio-matricula', 'cpf_pensao')"
                        [attr.aria-invalid]="!!erroCampoFormulario('beneficio-matricula', 'cpf_pensao')"
                        required
                      />
                      <div *ngIf="erroCampoFormulario('beneficio-matricula', 'cpf_pensao')" class="invalid-feedback d-block">
                        {{ erroCampoFormulario("beneficio-matricula", "cpf_pensao") }}
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    class="btn btn-primary mr-2"
                    [disabled]="salvandoDadosBeneficioMatricula"
                    (click)="salvarDadosBeneficioMatricula()"
                  >
                    {{ salvandoDadosBeneficioMatricula ? 'Salvando...' : 'Salvar dados da matrícula' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    [disabled]="salvandoDadosBeneficioMatricula"
                    (click)="cancelarEdicaoDadosBeneficioMatricula()"
                  >
                    Cancelar
                  </button>
                </div>
              </div>

              <hr />
              <h5>Movimentos Funcionais</h5>
              <ng-container *ngIf="isMatriculaSelecionadaAtiva(); else movimentoNaoAplicavel">
                <div class="movimentos-preview">
                  <div>
                    <b>{{ getMovimentosMatricula().length }}</b> movimento(s) funcional(is)
                    <span *ngIf="getMovimentosMatricula().length">
                      · cargo atual: <b>{{ getMovimentosMatricula()[0].cargo || '---' }}</b>
                    </span>
                  </div>
                  <span *ngIf="!getMovimentosMatricula().length">Nenhum movimento funcional cadastrado para esta matrícula.</span>
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-primary" (click)="navigateTo('page/servidor/dados-funcionais')">
                    {{ modoSomenteLeitura ? 'Visualizar' : 'Ver' }} histórico de movimentação <i class="fa fa-arrow-right ml-1"></i>
                  </button>
                </div>
              </ng-container>
              <ng-template #movimentoNaoAplicavel>
                <div class="regra-nao-aplica">
                  <i class="ft-info regra-nao-aplica-icone"></i>
                  <div>
                    <h6>Não se aplica à matrícula de {{ getStatus(matriculaSelecionada.status) | lowercase }}</h6>
                    <p>Movimentos funcionais existem apenas enquanto a matrícula é de servidor ativo.</p>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="tempo-servico-info" *ngIf="servidor">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="card-header-leading">
              <div class="card-title-group">
                <h4>Tempo de Serviço Passado (TSP)</h4>
                <span>Histórico profissional do CPF resumido</span>
              </div>
              <label class="conferencia-check" [class.conferido]="conferenciaBlocos.tsp" *ngIf="isConferidor && !modoSomenteLeitura && temMatriculaAtiva()">
                <input
                  type="checkbox"
                  [(ngModel)]="conferenciaBlocos.tsp"
                  [ngModelOptions]="{ standalone: true }"
                />
                Conferido?
              </label>
            </div>
            <div class="card-header-actions">
              <button class="btn-no-border" (click)="toggleTempoServico()">
                {{ isTempoServicoVisible ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
          </div>
          <div class="card-body" *ngIf="isTempoServicoVisible">
            <ng-container *ngIf="temMatriculaAtiva(); else tspNaoAplicavel">
              <div class="movimentos-preview mb-3">
                <b>{{ temposServico.length }}</b> sequência(s) · <b>{{ getTotalTempoServico() }}</b> dias cadastrados
              </div>
              <div class="table-responsive" *ngIf="temposServico.length">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr><th>Empregador</th><th>Matrícula</th><th>Período</th><th>Dias</th><th>Tipo</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tempo of temposServico | slice:0:3">
                      <td>{{ tempo.nome_empregrador || '---' }}</td>
                      <td>{{ tempo.matricula || 'Sem matrícula' }}</td>
                      <td>{{ beautifulDateSimple(tempo.data_entrada) || '---' }} – {{ beautifulDateSimple(tempo.data_fim) || '---' }}</td>
                      <td>{{ tempo.tempo_bruto || 0 }}</td>
                      <td>{{ tempo.rpps_rgps == 0 ? 'RPPS' : 'INSS' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-outline-primary" (click)="navigateTo('page/servidor/tempos')">
                  {{ isConferidor && !modoSomenteLeitura ? 'Conferir' : 'Ver' }} tempo de serviço <i class="fa fa-arrow-right ml-1"></i>
                </button>
              </div>
            </ng-container>
            <ng-template #tspNaoAplicavel>
              <div class="regra-nao-aplica">
                <i class="ft-info regra-nao-aplica-icone"></i>
                <div>
                  <h6>Não se aplica — nenhuma matrícula de ativo</h6>
                  <p>O tempo de serviço passado é exibido apenas quando o servidor possui ao menos uma matrícula de ativo.</p>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Card do Tempo de Atendimento e Links (apenas para não conferidores) -->
    <div class="col-lg-3 col-md-4 ficha-lateral" *ngIf="!isConferidor">
      <div class="card atendimento-card">
        <h5>Tempo de Atendimento</h5>
        <div class="row" *ngIf="servidor && !isMatriculaTemporaria()">
          <div class="col-7">
            <p class="time" *ngIf="servidor && servidor.atendimento != null">
              {{ servidor.atendimento }}
            </p>
            <p
              class="time"
              style="font-size: 1em"
              *ngIf="
                servidor.inicio_atendimento != null &&
                servidor.fim_atendimento == null
              "
            >
              Em Atendimento
            </p>
          </div>
          <div class="col-5 align-items-end">
            <div class="actions">
              <button
                [disabled]="
                  servidor.inicio_atendimento == null ||
                  (servidor.inicio_atendimento != null &&
                    servidor.fim_atendimento == null)
                "
                class="btn btn-rounded btn-outline-primary"
                (click)="openModal(comprovante)"
              >
                <i class="fa fa-file"></i>
              </button>
              <button
                (click)="iniciarAtendimento()"
                *ngIf="servidor.inicio_atendimento == null"
                class="btn btn-rounded btn-outline-primary"
              >
                <i class="fa fa-play"></i>
              </button>
              <button
                (click)="finalizarAtendimento()"
                *ngIf="
                  servidor.inicio_atendimento != null &&
                  servidor.fim_atendimento == null
                "
                class="btn btn-rounded btn-outline-primary"
              >
                <i class="fa fa-stop"></i>
              </button>
              <button
                (click)="reiniciarAtendimento()"
                *ngIf="
                  servidor.inicio_atendimento != null &&
                  servidor.fim_atendimento != null
                "
                class="btn btn-rounded btn-outline-primary"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="alert alert-info mx-3" *ngIf="servidor && isMatriculaTemporaria()">
          O atendimento ficará disponível quando uma matrícula real for cadastrada.
        </div>

        <div class="comprovante-status" *ngIf="servidor">
          <div class="comprovante-status__titulo">
            <i class="fa fa-envelope-o" aria-hidden="true"></i>
            <span>Comprovante por e-mail</span>
          </div>
          <ng-container *ngIf="ultimoEnvioComprovante; else comprovanteNaoEnviado">
            <span
              class="comprovante-status__badge"
              [ngClass]="classeStatusComprovante(ultimoEnvioComprovante.status)"
            >
              {{ ultimoEnvioComprovante.statusDescricao || ultimoEnvioComprovante.status }}
            </span>
            <small class="comprovante-status__horario">
              Enviado em
              {{
                ultimoEnvioComprovante.criadoEmUtc
                  | date: "dd/MM/yyyy 'às' HH:mm":"-0300"
              }}
              (GMT-3)
            </small>
          </ng-container>
          <ng-template #comprovanteNaoEnviado>
            <span class="comprovante-status__vazio">Ainda não enviado</span>
          </ng-template>
        </div>

        <label>Status de Agendamento</label>
        <ng-select
          [items]="statusAgenda"
          name="statusAgenda"
          *ngIf="servidor && servidor.agenda"
          bindLabel="descricao"
          bindValue="id"
          placeholder=""
          id="status_agenda"
          style="width: 280px"
          [(ngModel)]="servidor.agenda"
          (change)="updateAgendaStatus($event)"
          [disabled]="modoSomenteLeitura"
        >
        </ng-select>
        <button
          *ngIf="servidor && mostrarBotaoAtualizar && !modoSomenteLeitura"
          class="btn btn-primary mt-2"
          (click)="editarServidor()"
        >
          Atualizar
        </button>
      </div>

      <!-- Links Laterais -->
      <div class="sidebar-links mt-3">
        <button
          type="button"
          [disabled]="!temMatriculaAtiva()"
          (click)="navigateTo('page/servidor/dados-funcionais')"
          class="side-link"
          ><i class="fa fa-check-square-o"></i> Matrículas &amp; Movimentos</button
        >
        <button
          type="button"
          [disabled]="!temMatriculaAtiva()"
          (click)="navigateTo('page/servidor/tempos')"
          class="side-link"
          ><i class="fa fa-clock-o"></i> Tempo de Serviço Passado</button
        >
      </div>
    </div>

    <!-- Card de Controle de Conferência (apenas para conferidores) -->
    <div class="col-lg-3 col-md-4 ficha-lateral" *ngIf="isConferidor">
      <div class="card atendimento-card conferencia-card">
        <h5>Controle de Conferência</h5>
        <hr />
        <label class="conferencia-label">STATUS DE CONFERÊNCIA</label>
        <span class="conferencia-situacao" [class.finalizada]="servidor?.situacao_nova === 'conferido'">
          {{ getSituacaoConferenciaLabel() }}
        </span>
        <hr />
        <label class="conferencia-label progresso-label">PROGRESSO DE CONFERÊNCIA</label>
        <div class="conferencia-progresso">
          <div
            class="conferencia-passo"
            *ngFor="let passo of getPassosConferencia()"
            [class.conferido]="passo.conferido"
            [class.proximo]="passo.proximo"
          >
            <span class="passo-icone">{{ passo.conferido ? '✓' : '○' }}</span>
            <span>{{ passo.label }}</span>
            <span class="passo-proximo" *ngIf="passo.proximo">PRÓXIMO</span>
          </div>
        </div>
        <button
          *ngIf="!modoSomenteLeitura"
          type="button"
          class="btn btn-primary w-100"
          (click)="finalizarConferencia()"
          [disabled]="servidor?.situacao_nova === 'conferido' || !conferenciaCompleta()"
        >
          Finalizar Conferência
        </button>
        <p class="conferencia-nota mb-0">
          {{ modoSomenteLeitura
            ? 'Consulta sem alteração dos dados ou do andamento da conferência.'
            : 'Confira os dados do CPF uma vez e, depois, cada matrícula antes de finalizar.' }}
        </p>
      </div>

      <!-- Links Laterais para Conferidor -->
      <div class="sidebar-links mt-3">
        <button
          type="button"
          [disabled]="!temMatriculaAtiva()"
          (click)="navigateTo('page/servidor/dados-funcionais')"
          class="side-link"
          ><i class="fa fa-check-square-o"></i> Matrículas &amp; Movimentos</button
        >
        <button
          type="button"
          [disabled]="!temMatriculaAtiva()"
          (click)="navigateTo('page/servidor/tempos')"
          class="side-link"
          ><i class="fa fa-clock-o"></i> Tempo de Serviço Passado</button
        >
      </div>
    </div>
  </div>
</div>
<ng-template #cadastroMatricula let-modal>
  <form class="nova-matricula-modal formulario-validavel formulario-matricula" (ngSubmit)="adicionarMatricula(modal)" novalidate>
    <div class="modal-header">
      <h5 class="modal-title">Nova matrícula</h5>
      <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('Fechar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p class="nova-matricula-descricao">
        Cadastre o resumo da matrícula. Os demais dados do vínculo você completa na tela de detalhes.
      </p>
      <div class="nova-matricula-grid">
        <div class="form-group">
          <label for="nova_matricula">Nº da matrícula<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
          <input
            type="text"
            inputmode="numeric"
            mask="0*"
            id="nova_matricula"
            name="matricula"
            class="form-control"
            placeholder="Somente números"
            [(ngModel)]="novaMatricula.matricula"
            [class.is-invalid]="erroCampoFormulario('matricula', 'matricula')"
            [attr.aria-invalid]="!!erroCampoFormulario('matricula', 'matricula')"
            required
          />
          <div *ngIf="erroCampoFormulario('matricula', 'matricula')" class="invalid-feedback d-block">
            {{ erroCampoFormulario("matricula", "matricula") }}
          </div>
        </div>
        <div class="form-group">
          <label for="novo_status_matricula">Status<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
          <ng-select
            id="novo_status_matricula"
            name="status"
            [items]="statusNovaMatricula"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            [(ngModel)]="novaMatricula.status"
            [class.is-invalid]="erroCampoFormulario('matricula', 'status')"
            [attr.aria-invalid]="!!erroCampoFormulario('matricula', 'status')"
          ></ng-select>
          <div *ngIf="erroCampoFormulario('matricula', 'status')" class="invalid-feedback d-block">
            {{ erroCampoFormulario("matricula", "status") }}
          </div>
        </div>
        <div class="form-group">
          <label for="novo_municipio_matricula">Município</label>
          <input
            type="text"
            id="novo_municipio_matricula"
            class="form-control"
            [value]="getNomeCidadeMatricula()"
            disabled
          />
          <small>Definido pelo município em conferência</small>
        </div>
        <div class="form-group">
          <label for="novo_cargo_matricula">Cargo atual</label>
          <input
            type="text"
            id="novo_cargo_matricula"
            name="novo_cargo_matricula"
            class="form-control"
            placeholder="Opcional"
            [(ngModel)]="novaMatricula.cargo_atual"
          />
        </div>
        <div class="form-group">
          <label for="nova_data_nomeacao">Data de nomeação</label>
          <input
            type="date"
            lang="pt-BR"
            id="nova_data_nomeacao"
            name="nova_data_nomeacao"
            class="form-control"
            [(ngModel)]="novaMatricula.data_nomeacao"
          />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Voltar')">Voltar</button>
      <button type="submit" class="btn btn-primary">Salvar e abrir</button>
    </div>
  </form>
</ng-template>
<ng-template #cadastroAnexo let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title">Novo Anexo</h5>
    <button
      type="button"
      class="btn-close-modal"
      aria-label="Fechar"
      (click)="modal.dismiss('Close click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #servForm="ngForm" class="formulario-validavel formulario-anexo" novalidate>
      <div class="row align-items-end">
        <div class="col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="referencias">Referência<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
              <ng-select
                [appendTo]="'body'"
                [items]="referencias"
                name="referencia"
                placeholder="Referência"
                id="referencias"
                [(ngModel)]="anexo.referencia"
                [class.is-invalid]="erroCampoFormulario('anexo', 'referencia')"
                [attr.aria-invalid]="!!erroCampoFormulario('anexo', 'referencia')"
              ></ng-select>
              <div *ngIf="erroCampoFormulario('anexo', 'referencia')" class="invalid-feedback d-block">
                {{ erroCampoFormulario("anexo", "referencia") }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-block btn-outline-primary"
              [class.is-invalid]="erroCampoFormulario('anexo', 'arquivo')"
              [attr.aria-invalid]="!!erroCampoFormulario('anexo', 'arquivo')"
              (click)="fileInput.click()"
            >
              <i class="fa fa-upload"></i> Carregar Documento
              <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
            </button>
            <!-- Input file oculto -->
            <input
              #fileInput
              type="file"
              name="arquivo"
              (change)="selecionaArquivo($event)"
              class="d-none"
              accept=".xls,.xlsx,.docx,.pdf,.doc"
            />
            <div *ngIf="erroCampoFormulario('anexo', 'arquivo')" class="invalid-feedback d-block">
              {{ erroCampoFormulario("anexo", "arquivo") }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <!-- Botão Voltar -->
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="modal.dismiss('Voltar')"
        >
          Voltar
        </button>
        <!-- Botão Salvar -->
        <button
          type="button"
          class="btn btn-primary mb-2 mb-md-0 float-right"
          (click)="cadastrarAnexo(modal)"
        >
          Adicionar
        </button>
      </div>
    </form>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ng-template #cadastroDependente let-modal>
  <div class="container" [class.modo-somente-leitura]="modoSomenteLeitura">
    <div class="modal-header d-flex justify-content-between align-items-center">
      <h4 class="modal-title">
        {{ modoSomenteLeitura ? "Detalhes do Dependente" : "Novo Dependente" }}
      </h4>
      <button
        type="button"
        class="btn-close-modal"
        aria-label="Fechar"
        (click)="modal.dismiss('Close click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form #servForm="ngForm" class="formulario-validavel formulario-dependente" novalidate>
        <fieldset [disabled]="modoSomenteLeitura" class="border-0 p-0 m-0">
        <h5 class="text-left">Dados do Dependente</h5>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="tiposDependencia">Tipo Dependência</label>
                <ng-select
                  [appendTo]="'body'"
                  [items]="tiposDependencia"
                  name="tiposDependencia"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Tipo Dependência"
                  id="tiposDependencia"
                  [(ngModel)]="dependente.tipo_dependencia"
                ></ng-select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="motivosInicio">Motivo Início Dependência</label>
                <ng-select
                  [appendTo]="'body'"
                  [items]="motivosInicio"
                  name="motivosInicio"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Motivo Início Dependência"
                  id="motivosInicio"
                  [(ngModel)]="dependente.motivo_inicio"
                ></ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="nome">Nome <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="dependente.nome"
                  name="nome"
                  placeholder="Nome Completo"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'nome')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'nome')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'nome')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "nome") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="sexo">Sexo <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <ng-select
                  [appendTo]="'body'"
                  [items]="sexos"
                  name="sexo"
                  bindLabel="name"
                  placeholder="Sexo"
                  bindValue="id"
                  id="sexo"
                  [(ngModel)]="dependente.sexo"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'sexo')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'sexo')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'sexo')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "sexo") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="mae">Nome Mãe <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="mae"
                  class="form-control"
                  [(ngModel)]="dependente.nome_mae"
                  name="nome_mae"
                  placeholder="Nome Mãe"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'nome_mae')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'nome_mae')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'nome_mae')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "nome_mae") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="pai">Nome Pai</label>
                <input
                  type="text"
                  id="pai"
                  class="form-control"
                  [(ngModel)]="dependente.nome_pai"
                  name="pai"
                  placeholder="Nome Pai"
                  required
                  aria-invalid="false"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="data_nascimento"
                  >Nascimento <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <input
                  type="text"
                  id="data_nascimento"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="dependente.data_nascimento"
                  name="data_nascimento"
                  placeholder="Data Nascimento"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'data_nascimento')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'data_nascimento')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'data_nascimento')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "data_nascimento") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="estado_civil"
                  >Estado Civil <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="estadosCivis"
                  name="estado_civil"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Estado Civil"
                  id="estado_civil"
                  [(ngModel)]="dependente.estado_civil"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'estado_civil')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'estado_civil')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'estado_civil')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "estado_civil") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-3">
            <div class="form-group">
              <div class="controls">
                <label for="naturalizado"
                  >Naturalizado <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="naturalizados"
                  name="naturalizado"
                  bindLabel="name"
                  placeholder="Naturalizado"
                  bindValue="id"
                  id="naturalizado"
                  [(ngModel)]="dependente.naturalizado"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'naturalizado')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'naturalizado')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'naturalizado')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "naturalizado") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <div class="controls">
                <label for="estado"
                  >UF Naturalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="estados"
                  name="estado_naturalidade"
                  (change)="toggleEstadoDependente(true)"
                  bindLabel="estado"
                  bindValue="estado"
                  placeholder="Estado"
                  id="estado"
                  [(ngModel)]="dependente.estado_naturalidade"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'estado_naturalidade')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'estado_naturalidade')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'estado_naturalidade')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "estado_naturalidade") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="cidade"
                  >Cidade Naturalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="cidadesNaturalidade"
                  [disabled]="
                    !cidadesNaturalidade || cidadesNaturalidade.length == 0
                  "
                  name="cidade_naturalidade"
                  bindLabel="nome"
                  bindValue="id"
                  placeholder="Cidade"
                  id="cidade"
                  [(ngModel)]="dependente.cidade_naturalidade"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'cidade_naturalidade')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'cidade_naturalidade')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'cidade_naturalidade')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "cidade_naturalidade") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="nacionalidade"
                  >Nacionalidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <input
                  type="text"
                  id="nacionalidade"
                  class="form-control"
                  [(ngModel)]="dependente.nacionalidade"
                  name="nacionalidade"
                  placeholder="Nacionalidade"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'nacionalidade')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'nacionalidade')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'nacionalidade')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "nacionalidade") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="escolaridade"
                  >Escolaridade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="escolaridades"
                  name="escolaridade"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Escolaridade"
                  id="escolaridade"
                  [(ngModel)]="dependente.escolaridade"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'escolaridade')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'escolaridade')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'escolaridade')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "escolaridade") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="deficiente"
                  >Deficiente <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="naturalizados"
                  name="deficiente"
                  bindLabel="name"
                  placeholder="Deficiente"
                  bindValue="id"
                  id="deficiente"
                  [(ngModel)]="dependente.deficiente"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'deficiente')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'deficiente')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'deficiente')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "deficiente") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <h5 class="text-left">Documentos do Dependente</h5>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="cpf">CPF <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="cpf"
                  class="form-control"
                  [(ngModel)]="dependente.cpf"
                  mask="000.000.000-00"
                  name="cpf"
                  placeholder="CPF"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'cpf')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'cpf')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'cpf')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "cpf") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <h5 class="text-left">Endereço</h5>
        <div class="form-row">
          <div class="col">
            <div
              class="form-check copy-data-control"
              [class.copying]="copiandoEndereco"
              [class.copied]="enderecoCopiado"
            >
              <input
                (change)="copiaEndereco($event)"
                [checked]="checkEndereco"
                [disabled]="copiandoEndereco"
                type="checkbox"
                class="form-check-input"
                id="copia_end_serv"
              />
              <label class="form-check-label" for="copia_end_serv">
                <i *ngIf="copiandoEndereco" class="fa fa-circle-o-notch fa-spin copy-data-icon"></i>
                <i *ngIf="!copiandoEndereco && enderecoCopiado" class="fa fa-check-circle copy-data-icon"></i>
                <b>Copiar endereço do titular</b>
                <span *ngIf="enderecoCopiado" class="copy-data-feedback">Dados copiados</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="cep">CEP <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="cep"
                  class="form-control"
                  [(ngModel)]="dependente.cep"
                  mask="00.000-000"
                  name="cep"
                  placeholder="CEP"
                  (change)="consultaCep('dependente')"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'cep')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'cep')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'cep')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "cep") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="tiposlogradouro"
                  >Tipo Logradouro <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <ng-select
                  [appendTo]="'body'"
                  [items]="tiposLogradouro"
                  name="tipo_logradouro"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Tipo Logradouro"
                  id="tiposlogradouro"
                  [(ngModel)]="dependente.tipo_logradouro"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'tipo_logradouro')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'tipo_logradouro')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'tipo_logradouro')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "tipo_logradouro") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="estado1">Estado <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <ng-select
                  [appendTo]="'body'"
                  [items]="estados"
                  name="estado"
                  (change)="toggleEstadoDependente(false)"
                  bindLabel="estado"
                  bindValue="estado"
                  placeholder="Estado"
                  id="estado1"
                  [(ngModel)]="dependente.estado"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'estado')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'estado')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'estado')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "estado") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="cidade1">Cidade <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <ng-select
                  [appendTo]="'body'"
                  [items]="cidades"
                  [disabled]="!cidades || cidades.length == 0"
                  name="cidade"
                  bindLabel="nome"
                  bindValue="id"
                  placeholder="Cidade"
                  id="cidade1"
                  [(ngModel)]="dependente.cidade"
                  [class.is-invalid]="erroCampoFormulario('dependente', 'cidade')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'cidade')"
                ></ng-select>
                <div *ngIf="erroCampoFormulario('dependente', 'cidade')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "cidade") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="logradouro"
                  >Logradouro <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <input
                  type="text"
                  id="logradouro"
                  class="form-control"
                  [(ngModel)]="dependente.logradouro"
                  name="logradouro"
                  placeholder="Logradouro"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'logradouro')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'logradouro')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'logradouro')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "logradouro") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="numero">Número <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="numero"
                  class="form-control"
                  [(ngModel)]="dependente.numero"
                  name="numero"
                  placeholder="Número"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'numero')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'numero')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'numero')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "numero") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="bairro">Bairro <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
                <input
                  type="text"
                  id="bairro"
                  class="form-control"
                  [(ngModel)]="dependente.bairro"
                  name="bairro"
                  placeholder="Bairro"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'bairro')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'bairro')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'bairro')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "bairro") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="controls">
                <label for="complemento"
                  >Complemento <span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label
                >
                <input
                  type="text"
                  id="complemento"
                  class="form-control"
                  [(ngModel)]="dependente.complemento"
                  name="complemento"
                  placeholder="Complemento"
                  required
                  [class.is-invalid]="erroCampoFormulario('dependente', 'complemento')"
                  [attr.aria-invalid]="!!erroCampoFormulario('dependente', 'complemento')"
                />
                <div *ngIf="erroCampoFormulario('dependente', 'complemento')" class="invalid-feedback d-block">
                  {{ erroCampoFormulario("dependente", "complemento") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <h5 class="text-left">Contato</h5>
        <div class="form-row">
          <div class="col-12">
            <div
              class="form-check copy-data-control"
              [class.copying]="copiandoContatos"
              [class.copied]="contatosCopiados"
            >
              <input
                (change)="copiaContatos($event)"
                [checked]="checkContatos"
                [disabled]="copiandoContatos"
                type="checkbox"
                class="form-check-input"
                id="copia_cont_serv"
              />
              <label class="form-check-label" for="copia_cont_serv">
                <i *ngIf="copiandoContatos" class="fa fa-circle-o-notch fa-spin copy-data-icon"></i>
                <i *ngIf="!copiandoContatos && contatosCopiados" class="fa fa-check-circle copy-data-icon"></i>
                <b>Copiar contatos do titular</b>
                <span *ngIf="contatosCopiados" class="copy-data-feedback">Dados copiados</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="telefone">Telefone</label>
                <input
                  type="text"
                  id="telefone"
                  class="form-control"
                  [(ngModel)]="dependente.telefone"
                  mask="(00) 0000-0000"
                  name="telefone"
                  placeholder="Telefone"
                  required
                  aria-invalid="false"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="controls">
                <label for="celular">Celular</label>
                <input
                  type="text"
                  id="celular"
                  class="form-control"
                  [(ngModel)]="dependente.celular"
                  mask="(00) 00000-0000"
                  name="celular"
                  placeholder="Celular"
                  required
                  aria-invalid="false"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <div class="controls">
                <label for="email">Email</label>
                <input
                  type="text"
                  id="email"
                  class="form-control"
                  [(ngModel)]="dependente.email"
                  name="email"
                  placeholder="Email"
                  required
                  aria-invalid="false"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <button
              *ngIf="!modoSomenteLeitura"
              type="button"
              class="btn btn-lg btn-primary mb-2 mb-md-0 float-right"
              (click)="atualizarOuCadastrarDependente(modal)"
            >
              {{ dependente.id ? "Atualizar" : "Cadastrar" }}
            </button>
          </div>
        </div>
        </fieldset>
      </form>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ng-template #comprovante let-modal>
  <div
    class="modal-header d-flex justify-content-between align-items-center"
    style="border-bottom: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <h4
      class="modal-title mb-0"
      style="color: #333; font-weight: 500; font-size: 24px"
    >
      Relatório do Servidor
    </h4>
    <button
      type="button"
      class="btn-close-modal"
      aria-label="Fechar"
      (click)="modal.dismiss('Cross click')"
      title="Fechar"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="padding: 0">
    <div
      id="print-section"
      style="
        background: white;
        padding: 2rem;
        font-family: Arial, sans-serif;
        color: #333;
      "
    >
      <!-- Cabeçalho centralizado -->
      <div style="text-align: center; margin-bottom: 2rem">
        <h1
          style="
            color: #16a085;
            font-size: 40px;
            font-weight: 500;
            margin: 0 0 0.5rem 0;
          "
        >
          Prefeitura Municipal de {{ servidor.nomecidade || "" }}
        </h1>
        <p
          style="
            color: #666;
            margin: 0;
            font-size: 20px;
            line-height: 1.4;
            font-family: 'Montserrat', Arial, sans-serif;
          "
        >
          Você participou do censo previdenciário
          {{ getYear(servidor.inicio_atendimento) }} do regime próprio de
          previdência social<br />
          no município de {{ servidor.nomecidade || "" }}.
        </p>
      </div>

      <!-- Informações de atendimento em formato tabular -->
      <div style="margin-bottom: 2rem">
        <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Início do Atendimento: </span
          >
          <span
            style="
              font-family: monospace;
              font-weight: bold;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.inicio_atendimento) }}]</span
          >
        </div>
        <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Fim do Atendimento: </span
          >
          <span
            style="
              font-family: monospace;
              font-weight: bold;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.fim_atendimento) }}]</span
          >
        </div>
        <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Matrícula: </span
          >
          <span
            style="
              font-family: monospace;
              font-weight: bold;
              font-size: 20px;
              width: 70%;
            "
            >{{ servidor.matricula }}</span
          >
        </div>
      </div>

      <!-- Linha separadora -->
      <hr
        style="
          border: none;
          height: 1px;
          background-color: #ddd;
          margin: 2rem 0;
        "
      />

      <!-- Seção de informações do servidor -->
      <div style="display: flex; align-items: flex-end; gap: 2rem">
        <!-- Informações do servidor -->
        <div style="flex: 1">
          <h2
            style="
              color: #333;
              font-size: 24px;
              font-weight: 600;
              margin: 0 0 1.5rem 0;
            "
          >
            Informações do Servidor
          </h2>

          <!-- Layout tabular simples -->
          <div style="margin-bottom: 1rem">
            <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >NOME </span
              >
              <span
                style="
                  color: #333;
                  font-weight: bold;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.nome || "" }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >CPF </span
              >
              <span
                style="
                  color: #333;
                  font-weight: bold;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{
                  documentos?.cpf || servidor.cpf || servidor.cpf_pensao
                    | mask : "000.000.000-00"
                }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >IDENTIDADE </span
              >
              <span
                style="
                  color: #333;
                  font-weight: bold;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ documentos?.rg || "" }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE NASCIMENTO </span
              >
              <span
                style="
                  color: #333;
                  font-weight: bold;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ beautifulDateSimple(servidor.data_nascimento) }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem; gap: 0.75rem">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >STATUS </span
              >
              <span
                style="
                  color: #333;
                  font-weight: bold;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ getStatus(servidor.status) || "" }}</span
              >
            </div>
          </div>
        </div>

        <!-- Foto do servidor alinhada na parte inferior -->
        <div style="flex-shrink: 0">
          <div
            style="
              width: 150px;
              height: 150px;
              border-radius: 50%;
              overflow: hidden;
              background: #f0f0f0;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 2px solid #ddd;
            "
          >
            <img
              *ngIf="servidor.imagem"
              [src]="servidor.imagem"
              alt="Foto do servidor"
              style="width: 100%; height: 100%; object-fit: cover"
            />
            <div
              *ngIf="!servidor.imagem"
              style="color: #999; font-size: 12px; text-align: center"
            >
              Sem foto
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Rodapé com botões -->
  <div
    class="modal-footer d-flex justify-content-between"
    style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Close click')"
      style="padding: 0.5rem 1.5rem; border-radius: 4px"
    >
      Voltar
    </button>

    <div class="d-flex gap-2">
      <button
        type="button"
        class="btn btn-outline-success"
        (click)="openModalWhatsAppComprovante(modalWhatsAppComprovante, modal)"
        style="padding: 0.5rem 1.5rem; border-radius: 4px"
      >
        <i class="fa fa-whatsapp"></i> Enviar por WhatsApp
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="openModalEmailComprovante(modalEmailComprovante, modal)"
        style="padding: 0.5rem 1.5rem; border-radius: 4px"
      >
        <i class="fa fa-envelope-o"></i> Enviar por e-mail
      </button>
      <button
        type="button"
        class="btn"
        printTitle="Relatório do Servidor"
        printDelay="1000"
        printSectionId="print-section"
        ngxPrint
        style="
          background: #16a085;
          border-color: #16a085;
          color: white;
          padding: 0.5rem 1.5rem;
          border-radius: 4px;
        "
      >
        Salvar PDF
      </button>
    </div>
  </div>

  <ngx-spinner></ngx-spinner>
</ng-template>

<ng-template #modalWhatsAppComprovante let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Enviar comprovante por WhatsApp</h5>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-2">O PDF do comprovante será gerado, enviado para o servidor e depois encaminhado para o número informado.</p>
    <div class="form-group">
      <label for="whatsappNumero">Número do destinatário (Brasil)</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">+55</span>
        </div>
        <input
          type="tel"
          id="whatsappNumero"
          class="form-control"
          [(ngModel)]="whatsappDestinatario"
          placeholder="11 99999-9999"
          maxlength="20"
          [readonly]="enviandoComprovanteWhatsApp"
        />
      </div>
      <small class="form-text text-muted">DDI 55 já incluído. Digite apenas DDD + número (ex.: 11 99999-9999).</small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')" [disabled]="enviandoComprovanteWhatsApp">Cancelar</button>
    <button
      type="button"
      class="btn btn-success"
      (click)="enviarComprovanteWhatsApp(modal)"
      [disabled]="!podeEnviarWhatsApp() || enviandoComprovanteWhatsApp"
    >
      <span *ngIf="enviandoComprovanteWhatsApp"><i class="fa fa-spinner fa-spin mr-1"></i>Enviando...</span>
      <span *ngIf="!enviandoComprovanteWhatsApp"><i class="fa fa-whatsapp"></i> Enviar</span>
    </button>
  </div>
</ng-template>

<ng-template #modalEmailComprovante let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Enviar comprovante por e-mail</h5>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-2">
      O PDF será gerado e enviado ao armazenamento; o e-mail sai com texto e assunto definidos pelo sistema e o arquivo em anexo. Se o servidor tiver e-mail cadastrado nos contatos, informe o mesmo endereço.
    </p>
    <div class="form-group">
      <label for="emailComprovante">E-mail do destinatário</label>
      <input
        type="email"
        id="emailComprovante"
        class="form-control"
        [(ngModel)]="emailComprovanteDestinatario"
        placeholder="nome@exemplo.com"
        maxlength="254"
        [readonly]="enviandoComprovanteEmail"
        autocomplete="email"
      />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')" [disabled]="enviandoComprovanteEmail">Cancelar</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="enviarComprovanteEmail(modal)"
      [disabled]="!validarEmailComprovante() || enviandoComprovanteEmail"
    >
      <span *ngIf="enviandoComprovanteEmail"><i class="fa fa-spinner fa-spin mr-1"></i>Enviando...</span>
      <span *ngIf="!enviandoComprovanteEmail"><i class="fa fa-envelope-o"></i> Enviar</span>
    </button>
  </div>
</ng-template>

<ng-template #modalFoto let-modal>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content p-3">
        <div class="modal-header border-0">
          <h4 class="modal-title">Alterar Foto</h4>
        </div>
        <div class="modal-body text-center">
          <p>
            Permitido apenas JPG, JPEG ou PNG.<br />
            Tamanho máximo de arquivo 2mb.
          </p>

          <!-- Upload de imagem -->
          <label class="btn btn-outline-primary w-100 mb-2" for="select-files">
            <i class="fa fa-upload"></i> Carregar Foto
          </label>
          <input
            type="file"
            accept="image/*"
            (change)="uploadImage($event)"
            id="select-files"
            hidden
          />

          <!-- Tirar Foto -->
          <button
            type="button"
            class="btn btn-outline-primary w-100 mb-2"
            (click)="openModalCamera(takepicture)"
          >
            <i class="fa fa-camera"></i> Tirar Foto
          </button>

          <!-- Voltar -->
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            (click)="modal.close('Close click')"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #takepicture let-modal>
  <div class="row mb-2" id="print-section">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <p style="color: red">
            <b
              >Antes de capturar certifique-se de registrar uma foto onde o
              rosto do servidor estejam bem visível, com boa nitidez e
              luminosidade. Não permita utilizar bonés, óculos e nem sorrir!</b
            >
          </p>
        </div>
        <div class="card-content">
          <webcam
            [height]="500"
            [width]="500"
            [trigger]="triggerObservable"
            (imageCapture)="handleImage($event, modal)"
            [imageQuality]="1"
            [allowCameraSwitch]="true"
          ></webcam>
          <button
            type="button"
            class="btn btn-lg btn-primary mb-2 mb-md-0 btn-block"
            (click)="triggerSnapshot()"
          >
            Tirar Foto
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #miniEdicaoDadosServidor let-modal>
  <div
    class="modal-header d-flex justify-content-between align-items-center"
    style="border-bottom: 1px solid #e9ecef"
  >
    <h4 class="modal-title mb-0">Dados do Servidor</h4>
    <span
      (click)="modal.dismiss()"
      style="cursor: pointer; font-size: 1.5rem; line-height: 1; color: #000"
      aria-label="Fechar"
    >
      x
    </span>
  </div>

  <div class="modal-body">
    <form #servForm="ngForm" class="formulario-validavel formulario-mini" novalidate>
      <h5 class="text-left">Informações Básicas</h5>
      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="nome">Nome<span class="campo-obrigatorio-label">OBRIGATÓRIO</span></label>
              <input
                type="text"
                id="nome"
                class="form-control"
                [(ngModel)]="servidor.nome"
                name="nome"
                placeholder="Nome Completo"
                [class.is-invalid]="erroCampoFormulario('mini', 'nome')"
                [attr.aria-invalid]="!!erroCampoFormulario('mini', 'nome')"
                required
              />
              <div *ngIf="erroCampoFormulario('mini', 'nome')" class="invalid-feedback d-block">
                {{ erroCampoFormulario("mini", "nome") }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="cpf">
                CPF
                <span class="campo-obrigatorio-label">OBRIGATÓRIO</span>
              </label>
              <input
                type="text"
                id="cpf"
                class="form-control"
                [(ngModel)]="documentos.cpf"
                mask="000.000.000-00"
                name="cpf"
                placeholder="CPF"
                [class.is-invalid]="erroCampoFormulario('mini', 'cpf')"
                [attr.aria-invalid]="!!erroCampoFormulario('mini', 'cpf')"
                required
              />
              <div *ngIf="erroCampoFormulario('mini', 'cpf')" class="invalid-feedback d-block">
                {{ erroCampoFormulario("mini", "cpf") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="modal.dismiss('Voltar')"
        >
          Voltar
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2 mb-md-0 float-right"
          (click)="miniEditServidor(modal)"
        >
          Salvar Dados
        </button>
      </div>
    </form>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
